import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import { Context } from './Formbot';
export function Form(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var state = useContext(Context);
    return (React.createElement("form", __assign({ onSubmit: state && state.onSubmit }, props), children));
}
//# sourceMappingURL=Form.js.map